module.exports = __webpack_public_path__ + "img/MN.3ad554a1.png";